import styled from 'styled-components';

export const InfoPopup = styled.div<{ anchor: string }>`
  width: 300px;
  background: ${(props) => props.theme.background};
  position: absolute;
  padding: 10px 20px;
  box-shadow: 1px 1px 14px 1px rgb(0, 0, 0, 0.3);
  z-index: 30;
  visibility: ${(props) => (props.anchor === '' ? 'hidden' : 'visible')};

  ul {
    margin: 10px 0 0;
    padding: 0;
    list-style: none;
  }

  li {
    font-size: 14px;
    padding: 8px 0;
    border-bottom: 1px solid ${(props) => props.theme.keyline};
    text-align: center;
    color: ${(props) => props.theme.textDark};

    &:last-child {
      border-bottom: none;
    }
  }

  p {
    margin: 10px 0;
    font-size: 14px;
    text-align: center;
    color: ${(props) => props.theme.textDark};
  }

  &:after {
    content: '';
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    position: absolute;
  }

  ${(props) =>
    props.anchor === 'top-middle' &&
    `    
    &:after {
      border-bottom: 10px solid white;
      top: -10px;
      left: 150px;
    }
  `}

  ${(props) =>
    props.anchor === 'top-left' &&
    `    
    &:after {
      border-bottom: 10px solid white;
      top: -10px;
      left: 50px;
    }
  `}

  ${(props) =>
    props.anchor === 'top-right' &&
    `    
    &:after {
      border-bottom: 10px solid white;
      top: -10px;
      right: 50px;
    }
  `}

  ${(props) =>
    props.anchor === 'bottom-middle' &&
    `    
    &:after {
      border-top: 10px solid white;
      bottom: -10px;
      left: 150px;
    }
  `}

  ${(props) =>
    props.anchor === 'bottom-left' &&
    `    
    &:after {
      border-top: 10px solid white;
      bottom: -10px;
      left: 50px;
    }
  `}

  ${(props) =>
    props.anchor === 'bottom-right' &&
    `    
    &:after {
      border-top: 10px solid white;
      bottom: -10px;
      left: 230px;
    }
  `}
`;

export const InfoClose = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
`;

export const InfoTitle = styled.h5`
  color: ${(props) => props.theme.primary};
  text-align: center;
  font-weight: 600;
`;
